/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import MDInput from "components/MDInput";

import TextError from "utils/TextError";
// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

import FgHomePageCard from "layouts/home-cards/fgHomePageCard";
import PdiItemStatusHomePageCard from "layouts/home-cards/itemStatus";
import PdiPicklistHomePageCard from "layouts/home-cards/picklistAgeing";
import WarehouseEfficiancyCard from "layouts/home-cards/warehouseEfficiancyHomePageCard";
import WarehouseOccupancyHomePageCard from "layouts/home-cards/warehouseOccupancyHomePageCard";

import PdiItemAgeingHomePageCard from "layouts/home-cards/itemAgeing";

// Functions from store
import {
  createVendorRegistrationLink,
  getCalendarsForHome,
  getCircularsForHome,
  getFaqDetails,
  getNavbarBoxes,
  getSubModulesByRoleId,
  getVendorStatusCounts,
  getVendorSubscriptionCount,
} from "../../store";

// Cookies
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import Cookies from "universal-cookie";

// import DateRange from "utils/dateRangePicker";
import MDTypography from "components/MDTypography";

import { subMonths } from "date-fns";
import DateRangePicker from "rsuite/DateRangePicker";

// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import { addDays, endOfDay, startOfDay, subDays } from "date-fns";
import GrnHomePageCard from "layouts/home-cards/grnHomePageCard";
import Top10ReportsCard from "layouts/home-cards/top10";
import "rsuite/DateRangePicker/styles/index.css";

import { Backdrop, IconButton, Modal } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { Icon } from "@mui/material";

import EventCalendar from "utils/EventCalendar";

import MDCard from "components/MDCard";

import { Article, Notifications, QuestionAnswer } from "@mui/icons-material";
import VendorButton from "components/addVendor";
import VendorApplication from "layouts/home-cards/vendorApplicationTab";
import { useNavigate } from "react-router-dom";
import Config from "../../config/index";

const cookies = new Cookies();

const styleForSub = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForDesc = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: "fit-content",
  // border: "1px solid white",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForDocument = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 500, lg: 900, xl: 900 },
  overflow: "auto",
  height: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const Home = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getNavbarBoxesReducer,
  getNavbarBoxes,
  getCircularsForHome,
  getCircularsForHomeReducer,
  getCalendarsForHome,
  getCalendarsForHomeReducer,
  getFaqDetails,
  getFaqDetailsReducer,
  getVendorStatusCounts,
  getVendorStatusCountsReducer,
  createVendorRegistrationLink,
  getVendorSubscriptionCount,

  getVendorSubscriptionCountReducer,
  filled = 528,
  total = 1000,
}) => {
  const navigate = useNavigate();
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let roleName = loginDetails?.data?.roleName;
  let clientId = loginDetails?.data?.clientId;

  let baseUrl = Config.baseUrl;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  useEffect(() => {
    getVendorSubscriptionCount(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let homeModuleAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "6d79464e-9326-4210-bd0f-9beaac3a9310",
  );

  let warehouseOccupancyAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "9ef610d7-3b46-4559-a1ed-013da115200d",
  );

  let efficiencyAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "adc24e49-789f-4e0e-8f5a-d9efc2fa3c2b",
  );

  let grnReportAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "12bac273-485f-40d2-9af4-ee4e9bff1c85",
  );

  let bomMismatchAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "34faf9e3-d4e5-4685-97e2-088fbbbe232a",
  );

  let fgReportAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "e0d4e32b-919e-4823-8043-568a38f36931",
  );

  let itemStatusAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "ecbf358a-2ee2-4327-83e2-4d71e14de399",
  );

  let picklistAgeingAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "64e1d8c4-a3cb-4aec-ab63-758a2bcd5d12",
  );

  let inventoryAgeingAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "6f36821d-ff51-4662-b5e6-75446b4eac6d",
  );

  let stockAgeingReportAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "90d7e7d6-d5eb-4603-94ea-67f3a427ec7b",
  );

  let minMaxFailureAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "42720443-cfd9-4441-9476-6de6d59ce506",
  );

  let top10Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "da743cdd-94f8-4e2c-bf03-fdc68410d8c8",
  );

  let bannerAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "5f6c89fd-9430-4fda-ab93-5f1cb1e3987a",
  );

  let leaveCalendarAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "4cea495f-76f2-4121-b08b-f506a586db6d",
  );

  let calendarAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "4cea495f-76f2-4121-b08b-f506a586db6d",
  );

  let circularAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "f31d9365-8e52-4204-9e8e-eb47b5f964e1",
  );

  let faqAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "218e2047-55c5-4540-a7f0-f765916b9e7c",
  );

  let navbarBoxesAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "c486dcff-a13d-4515-91d4-ba8d0f3b90bf",
  );

  let vendorStatusCountAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "32334b55-8c44-4ae8-99e5-03fb35df9a77",
  );

  let addVendorAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "548b2122-42e9-4d11-83ec-5c0be4f212c2",
  );

  let subscriptionAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "1bbd3d42-ffb2-4f7c-9691-ea8cc5ac4301",
  );

  let recentVendorsAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "98749b3d-79e1-4196-80b8-e7e8a17611ee",
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCalendarsForHome(jwtToken);
  }, []);

  const [calendarData, setCalendarData] = useState([]);

  useEffect(() => {
    let tempCalendar = [];
    let data = getCalendarsForHomeReducer.calendars.data
      ? getCalendarsForHomeReducer.calendars.data
      : [];

    if (calendarAccess) {
      setLoading(getCalendarsForHomeReducer.loading);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }

    data.map((calendar) => {
      const calendarObject = {
        id: calendar.id,
        title: calendar.title,
        // description: calendar.description,
        start: calendar?.start,
        end: calendar?.end,
      };
      tempCalendar.push(calendarObject);
    });

    setCalendarData(tempCalendar);
  }, [getCalendarsForHomeReducer]);

  useEffect(() => {
    getCircularsForHome(jwtToken);
  }, []);
  let circularData = getCircularsForHomeReducer.circularsForHome.data
    ? getCircularsForHomeReducer.circularsForHome.data
    : [];

  useEffect(() => {
    getFaqDetails(jwtToken);
  }, []);

  const [isErrorMsgCreateDocument, setIsErrorMsgCreateDocument] = useState("");

  // const faqData = [
  //   {
  //     name: "ASN Creation Procedure",
  //     type: "Step-by-step guide for creating Advanced Shipping Notifications",
  //   },
  //   {
  //     name: "How To Download ASN",
  //     type: "Instructions for downloading ASN documents and reports",
  //   },
  //   {
  //     name: "Schedule Forecasts And Status Acknowledgement",
  //     type: "Managing delivery schedules and status confirmations",
  //   },
  // ];

  let faqData = getFaqDetailsReducer.faq.data
    ? getFaqDetailsReducer.faq.data
    : [];

  const [openCircularModal, setOpenCircularModal] = useState(false);

  const [singleCircularData, setSingleCircularData] = useState({});
  const handleOpenCircularModal = (asnData = {}) => {
    setSingleCircularData(asnData);
    setOpenCircularModal(true);
  };
  const handleCloseCircularModal = () => {
    setOpenCircularModal(false);
    // formikForUpdate.setErrors({});
  };

  const [openViewEventDescModal, setOpenViewEventDescModal] = useState(false);

  const [singleEventDescData, setSingleEventDescData] = useState({});
  const handleOpenViewEventDescModal = (asnData = {}) => {
    setSingleEventDescData(asnData);
    setOpenViewEventDescModal(true);
  };
  const handleCloseViewEventDescModal = () => {
    setOpenViewEventDescModal(false);
    // formikForUpdate.setErrors({});
  };

  const [document, setDocument] = useState("");

  const [openViewDocumentModal, setOpenViewDocumentModal] = useState(false);

  const handleOpenViewDocumentModal = (Data = {}) => {
    setOpenViewDocumentModal(true);
    setDocument(Data);
  };

  const handleCloseViewDocumentModal = () => {
    setOpenViewDocumentModal(false);
  };

  useEffect(() => {
    getNavbarBoxes(jwtToken);
  }, []);

  const [navarBoxesData, setNavarBoxesData] = useState({});

  useEffect(() => {
    let data = getNavbarBoxesReducer.navbarBoxes?.data
      ? getNavbarBoxesReducer.navbarBoxes.data
      : {};

    setNavarBoxesData(data);
  }, [getNavbarBoxesReducer]);

  useEffect(() => {
    getVendorStatusCounts(jwtToken);
  }, []);

  const [vendorStatusData, setVendorStatusData] = useState([]);

  useEffect(() => {
    let data = getVendorStatusCountsReducer.vendorStatusCounts.data
      ? getVendorStatusCountsReducer.vendorStatusCounts.data[0]
      : [];

    setVendorStatusData(data);
  }, [getVendorStatusCountsReducer]);

  const [dateRangeSelected, setDateRangeSelected] = useState([
    startOfDay(subDays(new Date(), 6)),
    endOfDay(new Date()),
  ]);

  const [flag, setFlag] = useState(false);

  // const bomMistmatchData = [
  //   {
  //     count: 800,
  //     percentage: "+10%",
  //   },
  //   {
  //     count: 500,
  //     percentage: "+5%",
  //   },
  // ];

  // const minMaxData = [
  //   {
  //     count: 300,
  //     percentage: "+20%",
  //   },
  //   {
  //     count: 500,
  //     percentage: "+5%",
  //   },
  // ];

  // const fgData = [
  //   {
  //     count: 100,
  //     percentage: "+5%",
  //   },
  //   {
  //     count: 500,
  //     percentage: "+5%",
  //   },
  // ];

  const Ranges = [
    {
      label: "today",
      value: [startOfDay(new Date()), endOfDay(new Date())],
    },
    {
      label: "yesterday",
      value: [
        startOfDay(addDays(new Date(), -1)),
        endOfDay(addDays(new Date(), -1)),
      ],
    },
    {
      label: "last 30 Days",
      value: [startOfDay(subDays(new Date(), 29)), endOfDay(new Date())],
    },
  ];

  // const minDate = subDays(new Date(), 60);
  // const maxDate = new Date();

  const [search, setSearch] = useState("");

  const filteredFaqs = faqData?.filter(
    (faq) =>
      faq.keyName.toLowerCase().includes(search.toLowerCase()) ||
      faq.type.toLowerCase().includes(search.toLowerCase()),
  );

  const [search2, setSearch2] = useState("");

  const filteredCirculars = circularData?.filter(
    (faq) =>
      faq.startDate.toLowerCase().includes(search2.toLowerCase()) ||
      faq.title.toLowerCase().includes(search2.toLowerCase()),
  );
  const minDate = startOfDay(subMonths(new Date(), 6));
  const maxDate = endOfDay(new Date());

  const [dateError, setDateError] = useState("");

  const [errorMsg, setErrorMsg] = useState("");

  const initialValues = {
    vendorName: "",
    contactPerson: "",
    email: "",
  };

  const validationSchema = Yup.object({
    vendorName: Yup.string().required("Enter the name!"),
    contactPerson: Yup.string().required("Enter the Contact Person!"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Enter the E-Mail!"),
  });

  const [isErrorCreateUser, setIsErrorCreateUser] = useState(false);
  const [isSuccessCreateUser, setIsSuccessCreateUser] = useState(false);
  const [isErrorForEmail, setIsErrorForEmail] = useState(false);

  useEffect(() => {
    if (isSuccessCreateUser) {
      setTimeout(() => {
        setIsSuccessCreateUser(false);
      }, 3000);
    }
  }, [isSuccessCreateUser]);

  useEffect(() => {
    if (isErrorCreateUser) {
      setTimeout(() => {
        setIsErrorCreateUser(false);
      }, 3000);
    }
  }, [isErrorCreateUser]);

  const onSubmit = async (values, { resetForm }) => {
    let payload = {
      vendorName: values.vendorName,

      email: values.email,
      contactPerson: values.contactPerson,
      clientId: loginDetails.data.clientId,
    };
    const res = await createVendorRegistrationLink(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreateUser(true);
      resetForm();
    }
    if (!res.status) {
      setIsErrorCreateUser(true);
      if (res?.code === "E_VEN_001") {
        setErrorMsg(res?.msg);
      } else setErrorMsg(res?.data?.data?.msg);

      if (res?.code === "E_VEN_001") {
        handleOpenCreateVendorModal();
      }
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [openCreateVendorModal, setOpenCreateVendorModal] = useState(false);

  const handleOpenCreateVendorModal = () => {
    setOpenCreateVendorModal(true);
  };
  const handleCloseCreateVendorModal = () => {
    setOpenCreateVendorModal(false);
  };

  const [createDocumentModal, setCreateDocumentModal] = useState(false);

  const handleCreateDocumentModal = () => {
    setCreateDocumentModal(true);
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };
  const handleCreateCloseDocumentModal = () => {
    setCreateDocumentModal(false);
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };

  const [data, setData] = useState(null);
  useEffect(() => {
    let apiData = getVendorSubscriptionCountReducer.warehouses?.data
      ? getVendorSubscriptionCountReducer.warehouses.data
      : null;

    if (apiData) {
      setData({
        total: apiData.subscriptionCount,
        filled: apiData.vendorCount,
      });
    }
  }, [getVendorSubscriptionCountReducer]);

  console.log("data", data);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!loading ? (
        <>
          <MDBox
            mt={4}
            mb={0}
            display="flex"
            justifyContent="flex-end"
            width="100%"
          >
            {(fgReportAccess || grnReportAccess || itemStatusAccess) &&
              roleName !== "superadmin" && (
                <MDBox ml={2} display="flex" alignItems="center">
                  {[
                    {
                      label: "1W",
                      range: [
                        startOfDay(subDays(new Date(), 6)),
                        endOfDay(new Date()),
                      ],
                      isDefault: true,
                    },
                    {
                      label: "1M",
                      range: [
                        startOfDay(subDays(new Date(), 29)),
                        endOfDay(new Date()),
                      ],
                    },
                    {
                      label: "3M",
                      range: [
                        startOfDay(subDays(new Date(), 89)),
                        endOfDay(new Date()),
                      ],
                    },
                    {
                      label: "6M",
                      range: [
                        startOfDay(subDays(new Date(), 179)),
                        endOfDay(new Date()),
                      ],
                    },
                  ].map((shortcut) => {
                    // If nothing selected, default to 1W
                    const isActive =
                      (dateRangeSelected &&
                        dateRangeSelected.length === 2 &&
                        dateRangeSelected[0] &&
                        dateRangeSelected[1] &&
                        dateRangeSelected[0].toDateString() ===
                          shortcut.range[0].toDateString() &&
                        dateRangeSelected[1].toDateString() ===
                          shortcut.range[1].toDateString()) ||
                      (!dateRangeSelected?.length && shortcut.isDefault);

                    return flag === true ? (
                      <MDTypography
                        key={shortcut.label}
                        variant="button"
                        sx={{
                          cursor: "pointer",
                          px: 1,
                          py: 0.5,
                          borderRadius: 1,
                          mx: 0.5,
                          fontWeight: 500,
                          "&:hover": { backgroundColor: "#e0e0e0" },
                          backgroundColor: "#f5f5f5",
                          color: "#111",
                        }}
                      >
                        {shortcut.label}
                      </MDTypography>
                    ) : (
                      <MDTypography
                        key={shortcut.label}
                        variant="button"
                        sx={{
                          cursor: "pointer",
                          px: 1,
                          py: 0.5,
                          borderRadius: 1,
                          mx: 0.5,
                          fontWeight: 500,
                          "&:hover": { backgroundColor: "#e0e0e0" },
                          backgroundColor: isActive ? "#1A73E8" : "#f5f5f5",
                          color: isActive ? "#fff" : "#111",
                        }}
                        onClick={() => {
                          setDateRangeSelected(shortcut.range);
                        }}
                      >
                        {shortcut.label}
                      </MDTypography>
                    );
                  })}
                </MDBox>
              )}

            {/* <DateRangePicker
              ranges={Ranges}
              placeholder="Custom Date Range"
              showOneCalendar
              shouldDisableDate={(date) =>
                !(date >= minDate && date <= maxDate)
              }
              onChange={(value) => {
                console.log("Changed Range: ", value);
                setDateRangeSelected(value);
                setFlag(true);
              }}
              onClean={() => {
                console.log("Date Range Picker closed");
                setFlag(false);
                setDateRangeSelected([
                  startOfDay(subDays(new Date(), 6)),
                  endOfDay(new Date()),
                ]);
              }}
            /> */}
            {(fgReportAccess || grnReportAccess || itemStatusAccess) && (
              <DateRangePicker
                ranges={Ranges}
                placeholder="Custom Date Range"
                showOneCalendar
                shouldDisableDate={(date) =>
                  !(date >= minDate && date <= maxDate)
                }
                onChange={(value) => {
                  if (
                    Array.isArray(value) &&
                    value.length === 2 &&
                    value[0] instanceof Date &&
                    !isNaN(value[0]) &&
                    value[1] instanceof Date &&
                    !isNaN(value[1])
                  ) {
                    setDateRangeSelected(value);
                    setFlag(true);
                    setDateError("");
                  } else {
                    setDateError("Please select a valid date range.");
                    setDateRangeSelected([]);
                    setFlag(false);
                  }
                }}
                onClean={() => {
                  setFlag(false);
                  setDateRangeSelected([
                    startOfDay(subDays(new Date(), 6)),
                    endOfDay(new Date()),
                  ]);
                }}
                inputProps={{ readOnly: true }}
              />
            )}
          </MDBox>

          <MDBox
            display="flex"
            // justifyContent="flex-end"
            alignItems="center"
            gap={2}
            mt={1}
            mb={-1}
            // sx={{ marginTop: "2rem" }}
          >
            {subscriptionAccess && (
              <MDBox
                display="flex"
                justifyContent="flex-start"
                sx={{
                  borderRadius: "5px",
                  border: "1px solid red",
                  color: "red",
                  fontWeight: 500,
                  fontSize: "0.8rem",
                  padding: "4px 12px",
                  backgroundColor: "white",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MDTypography
                  sx={{
                    color: "red",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate("/subscription-plans");
                  }}
                >
                  Subscription: {data?.filled}/{data?.total} suppliers
                </MDTypography>
              </MDBox>
            )}
            {addVendorAccess && (
              <MDBox display="flex" justifyContent="flex-end" ml="auto">
                <VendorButton
                  tooltip="Add Supplier"
                  color="info"
                  variant="contained"
                  type="button"
                  onClick={(event) => handleCreateDocumentModal()}
                  sx={{ minWidth: "140px" }} // ensures button has proper width
                >
                  Add Supplier
                  <Icon sx={{ ml: 1 }}>add</Icon>
                </VendorButton>
              </MDBox>
            )}
          </MDBox>

          {navbarBoxesAccess && (
            <Grid container spacing={3} mt={0}>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="dark"
                    icon="category"
                    title="Count"
                    count={navarBoxesData?.BOM?.totalBOMCount ?? "-"}
                    cardTitle="Bom Mismatch"
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    icon="leaderboard"
                    title="Count"
                    count={
                      navarBoxesData?.minMaxFailure?.totalMinMaxCount ?? "-"
                    }
                    cardTitle="Min Max Failure"
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="warning"
                    icon="store"
                    title="Count"
                    count={navarBoxesData?.FG?.totalFGCount ?? "-"}
                    cardTitle="Total FG"
                  />
                </MDBox>
              </Grid>
            </Grid>
          )}

          {vendorStatusCountAccess && (
            <Grid container spacing={3} mt={0} mb={0}>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox
                  mb={1.5}
                  onClick={() => {
                    navigate("/status");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <ComplexStatisticsCard
                    icon="text_snippet"
                    title="Count"
                    count={
                      vendorStatusData.newRequests
                        ? vendorStatusData.newRequests
                        : 0
                    }
                    cardTitle="New Requests"
                    // percentage={{
                    //   color: "success",
                    //   amount: navarBoxesData?.bom?.comparison?.percentageChange
                    //     ? navarBoxesData.bom.comparison.percentageChange + "%"
                    //     : "0%",
                    //   label: "than lask week",
                    // }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox
                  mb={1.5}
                  onClick={() => {
                    navigate("/registered-suppliers");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <ComplexStatisticsCard
                    color="success"
                    icon="checkbox"
                    title="Count"
                    count={
                      vendorStatusData.approved ? vendorStatusData.approved : 0
                    }
                    cardTitle="Approved"
                    // percentage={{
                    //   color: "success",
                    //   amount: navarBoxesData?.minMaxFailior?.comparison
                    //     .percentageChange
                    //     ? navarBoxesData?.minMaxFailior?.comparison
                    //         .percentageChange + "%"
                    //     : "0%",
                    //   label: "than lask week",
                    // }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox
                  mb={1.5}
                  onClick={() => {
                    navigate("/status");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <ComplexStatisticsCard
                    color="warning"
                    icon="access_time"
                    title="Count"
                    count={
                      vendorStatusData.pending ? vendorStatusData.pending : 0
                    }
                    cardTitle="Pending"
                    // percentage={{
                    //   color: "success",
                    //   amount: navarBoxesData?.fg?.comparison.percentageChange
                    //     ? navarBoxesData.fg.comparison.percentageChange + "%"
                    //     : "0%",
                    //   label: "than lask week",
                    // }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox
                  mb={1.5}
                  onClick={() => {
                    navigate("/rejected-suppliers");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <ComplexStatisticsCard
                    color="error"
                    icon="error"
                    title="Count"
                    count={
                      vendorStatusData.rejected ? vendorStatusData.rejected : 0
                    }
                    cardTitle="Rejected"
                    // percentage={{
                    //   color: "success",
                    //   amount: navarBoxesData?.fg?.comparison.percentageChange
                    //     ? navarBoxesData.fg.comparison.percentageChange + "%"
                    //     : "0%",
                    //   label: "than lask week",
                    // }}
                  />
                </MDBox>
              </Grid>
            </Grid>
          )}
          {recentVendorsAccess && (
            <Grid container spacing={3} mt={0}>
              <Grid item xs={12} md={12} lg={12}>
                <VendorApplication />
              </Grid>
            </Grid>
          )}
          <Grid container spacing={4} mt={1}>
            {warehouseOccupancyAccess && (
              <Grid item xs={12} md={6} lg={4} mb={2}>
                <WarehouseOccupancyHomePageCard />
              </Grid>
            )}
            {grnReportAccess && (
              <Grid item xs={12} md={6} lg={4} mb={2}>
                <GrnHomePageCard
                  startDate={dateRangeSelected ? dateRangeSelected[0] : ""}
                  endDate={dateRangeSelected ? dateRangeSelected[1] : ""}
                />
              </Grid>
            )}
            {fgReportAccess && (
              <Grid item xs={12} md={6} lg={4} mb={2}>
                <FgHomePageCard
                  startDate={dateRangeSelected ? dateRangeSelected[0] : ""}
                  endDate={dateRangeSelected ? dateRangeSelected[1] : ""}
                />
              </Grid>
            )}

            {inventoryAgeingAccess && (
              <Grid item xs={12} md={6} lg={4} mb={2}>
                <PdiItemAgeingHomePageCard />
              </Grid>
            )}

            {picklistAgeingAccess && (
              <Grid item xs={12} md={6} lg={4} mb={2}>
                <PdiPicklistHomePageCard />
              </Grid>
            )}

            {itemStatusAccess && (
              <Grid item xs={12} md={6} lg={4} mb={2}>
                <PdiItemStatusHomePageCard
                  startDate={dateRangeSelected ? dateRangeSelected[0] : ""}
                  endDate={dateRangeSelected ? dateRangeSelected[1] : ""}
                />
              </Grid>
            )}
          </Grid>

          <Grid container spacing={3}>
            {top10Access && (
              <Grid item xs={12} md={6} lg={8}>
                <Top10ReportsCard />
              </Grid>
            )}
            <Grid item xs={12} md={6} lg={4} mb={2}>
              {efficiencyAccess && <WarehouseEfficiancyCard />}
            </Grid>

            {calendarAccess && (
              <Grid item xs={12} mt={navbarBoxesAccess ? 0 : -1} mb={1}>
                <EventCalendar data={calendarData} />
              </Grid>
            )}
          </Grid>
          <Grid container spacing={3}>
            {circularAccess && (
              <Grid
                item
                xs={12}
                lg={6}

                // ml={{ xs: 0, lg: !circularAccess && !calendarAccess ? 0 : 10 }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    boxShadow: "0 1px 8px rgba(16,30,54,0.06)",
                    padding: "24px",
                    minHeight: "355px",
                    maxHeight: "355px",
                    // maxWidth: "1000px",

                    overflowX: "auto",
                    border: "1px solid #f3f3f3",
                    position: "relative",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 24,
                    }}
                  >
                    <Notifications
                      color="#FF6600"
                      size={22}
                      style={{ marginRight: 10 }}
                    />
                    <span
                      style={{ fontSize: 18, fontWeight: 500, color: "#222" }}
                    >
                      Circulars
                    </span>
                    {/* <span
                      style={{
                        marginLeft: "auto",
                        background: "#f3f3f3",
                        color: "#222",
                        borderRadius: "16px",
                        padding: "4px 14px",
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      0 New
                    </span> */}
                  </div>
                  {circularData.length > 0 && (
                    <input
                      type="text"
                      placeholder="Search Circular..."
                      value={search2}
                      onChange={(e) => setSearch2(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px 14px",
                        borderRadius: 8,
                        border: "1px solid #eee",
                        marginBottom: 24,
                        background: "#f7f7fa",
                      }}
                    />
                  )}

                  {/* Center Content */}
                  {circularData.length > 0 ? (
                    <span>
                      {/* {filteredCirculars.map((circulars, idx) => (
                        <div
                          key={idx}
                          style={{
                            marginBottom: 12,
                            borderBottom:
                              idx < filteredFaqs.length - 1
                                ? "1px solid #eee"
                                : "none",
                            paddingBottom: 8,
                          }}
                        >
                          {circulars?.startDate && (
                            <h4
                              style={{ cursor: "pointer" }}
                              className="faqhover"
                            >
                              <MDBox
                                style={{
                                  marginTop: "-15px",

                                  display: "flex",
                                }}
                              >
                                <MDBox style={{ marginRight: "10px" }}>
                                  {new Date(circulars?.startDate).getDate() >
                                  9 ? (
                                    <MDBox
                                      style={{
                                        marginTop: "5px",

                                        background: "none",
                                        color: "#284B63",
                                        fontWeight: 600,
                                        fontSize: "15px",
                                        padding: "5px",
                                      }}
                                    >
                                      {circulars?.title.substring(0, 15)}{" "}
                                    </MDBox>
                                  ) : (
                                    <MDBox
                                      style={{
                                        marginTop: "5px",

                                        background: "none",
                                        color: "#284B63",
                                        fontWeight: 600,
                                        fontSize: "15px",
                                        padding: "5px",
                                        marginLeft: "3px",
                                      }}
                                    >
                                      {circulars?.title.substring(0, 15)}{" "}
                                    </MDBox>
                                  )}
                                </MDBox>

                                <MDBox
                                  mt={1}
                                  style={{
                                    float: "right",
                                    display: "flex",
                                    marginLeft: "auto",
                                    justifyContent: "right",
                                  }}
                                >
                                  <Tooltip title="View Description">
                                    <MDButton
                                      variant="gradient"
                                      color="success"
                                      size="small"
                                      type="button"
                                      onClick={() => {
                                        handleOpenViewEventDescModal(circulars);
                                      }}
                                      iconOnly
                                      style={{
                                        marginRight: "5px",
                                        // marginBottom: "5px",
                                        zIndex: 0,
                                        // background: "#009164",
                                        // color: "white",
                                      }}
                                    >
                                      <Icon> visibility_icon </Icon>
                                    </MDButton>
                                  </Tooltip>
                                </MDBox>
                              </MDBox>
                              <div className="text-gray-600 text-sm mb-2">
                                {circulars.description}
                              </div>
                              <hr style={{ color: "#284B63" }} />
                            </h4>
                          )}
                        </div>
                      ))} */}

                      <div>
                        {filteredCirculars.map((circulars, idx) => (
                          <div
                            key={idx}
                            style={{
                              marginBottom: 12,
                              borderBottom:
                                idx < filteredFaqs.length - 1
                                  ? "1px solid #eee"
                                  : "none",
                              paddingBottom: 8,
                            }}
                          >
                            <div className="flex items-center justify-between mb-1"></div>
                            <div
                              className="font-semibold text-base mb-1"
                              style={{ display: "flex" }}
                            >
                              <MDBox style={{ marginRight: "10px" }}>
                                {new Date(circulars?.startDate).getDate() >
                                9 ? (
                                  <MDBox
                                    style={{
                                      background: "none",
                                      color: "#284B63",
                                      fontWeight: 600,
                                      fontSize: "15px",
                                    }}
                                  >
                                    {circulars?.title.substring(0, 30)}{" "}
                                  </MDBox>
                                ) : (
                                  <MDBox
                                    style={{
                                      background: "none",
                                      color: "#284B63",
                                      fontWeight: 600,
                                      fontSize: "15px",

                                      marginLeft: "3px",
                                    }}
                                  >
                                    {circulars?.title.substring(0, 30)}{" "}
                                  </MDBox>
                                )}
                              </MDBox>

                              <span
                                className="text-gray-400 text-sm"
                                style={{ float: "right", marginLeft: "auto" }}
                              >
                                <MDBox style={{ marginRight: "20px" }}>
                                  <MDBox
                                    style={{
                                      // background: "none",
                                      // color: "grey",
                                      fontWeight: 400,
                                      fontSize: "13px",
                                      marginTop: "7px",
                                    }}
                                  >
                                    {new Date(
                                      circulars?.startDate,
                                    ).toLocaleString("default", {
                                      month: "short",
                                    })}{" "}
                                    {new Date(circulars?.startDate).getDate() <
                                    10
                                      ? "0" +
                                        new Date(circulars?.startDate).getDate()
                                      : new Date(
                                          circulars?.startDate,
                                        ).getDate()}{" "}
                                  </MDBox>
                                </MDBox>
                              </span>
                            </div>

                            {/* <div className="flex items-center gap-2 mb-2">
                                <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs font-medium">
                                  {circular.type}
                                </span>
                                <span className="text-xs text-gray-500">
                                  {circular.size}
                                </span>
                              </div> */}
                            <div className="flex items-center justify-between">
                              <div className="text-gray-600 text-sm mb-2">
                                {circulars.description.substring(0, 40)}
                              </div>
                              {/* <span className="text-xs text-gray-400">
                                  {circular.id}
                                </span> */}

                              <div
                                className="flex items-center text-gray-700 hover:text-blue-600 text-sm font-medium"
                                onClick={() => {
                                  handleOpenViewEventDescModal(circulars);
                                }}
                                style={{
                                  float: "right",
                                  marginLeft: "auto",
                                  cursor: "pointer",
                                }}
                              >
                                <Icon
                                  style={{
                                    marginTop: "5px",
                                    marginRight: "5px",
                                  }}
                                >
                                  visibility
                                </Icon>{" "}
                                View Description
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </span>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: 40,
                      }}
                    >
                      <div
                        style={{
                          background: "#FFEEDB",
                          borderRadius: "50%",
                          width: 80,
                          height: 80,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: 24,
                        }}
                      >
                        <Article
                          style={{ width: 500 }}
                          color="warning"
                          fontSize="large"
                        />
                      </div>
                      <div
                        style={{ fontWeight: 600, fontSize: 20, color: "#222" }}
                      >
                        No Latest Circulars
                      </div>
                      <div
                        style={{
                          color: "#7A7A7A",
                          fontSize: 15,
                          marginTop: 8,
                          marginBottom: 28,
                          textAlign: "center",
                          maxWidth: 420,
                        }}
                      >
                        You're all caught up! New circulars will appear here
                        when available.
                      </div>

                      {/* Browse Archive Button */}
                      {/* <div
                      style={{
                        width: 520,
                        maxWidth: "100%",
                        marginBottom: 18,
                      }}
                    >
                      <button
                        style={{
                          width: "100%",
                          background: "#fff",
                          border: "1px solid #e5e5e5",
                          borderRadius: 8,
                          padding: "10px 0",
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#222",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          outline: "none",
                          transition: "border 0.2s",
                        }}
                      >
                        <Search style={{ marginRight: 8 }} />
                        Browse Archive
                      </button>
                    </div> */}

                      {/* Set Notifications */}
                      {/* <div
                      style={{
                        color: "#222",
                        fontWeight: 500,
                        fontSize: 16,
                        cursor: "pointer",
                        textAlign: "center",
                      }}
                    >
                      Set Notifications
                    </div> */}
                    </div>
                  )}
                </div>
              </Grid>
            )}
            {/* <Grid item xs={12} lg={4}>
              <MDBox style={{ height: "355px", overflow: "auto" }}>
                <FaqCard />
              </MDBox>
            </Grid> */}
            {faqAccess && (
              <Grid
                item
                xs={12}
                lg={6}

                // ml={{ xs: 0, lg: !circularAccess && !calendarAccess ? 0 : 10 }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                    padding: 24,
                    // maxWidth: 600,
                    margin: "auto",
                    overflow: "auto",
                    height: "355px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 16,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 20,
                        marginRight: 8,
                        // color: "#2563eb",
                        marginTop: "5px",
                      }}
                    >
                      <QuestionAnswer />
                    </span>
                    <span style={{ fontWeight: 600, fontSize: 18 }}>FAQ</span>
                    {/* <a
                      href="#"
                      style={{
                        marginLeft: "auto",
                        color: "#2563eb",
                        fontWeight: 500,
                        textDecoration: "none",
                      }}
                    >
                      View All
                    </a> */}
                  </div>
                  <input
                    type="text"
                    placeholder="Search FAQ..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 14px",
                      borderRadius: 8,
                      border: "1px solid #eee",
                      marginBottom: 24,
                      background: "#f7f7fa",
                    }}
                  />
                  <div>
                    {filteredFaqs.map((faq, idx) => (
                      <div
                        key={idx}
                        style={{
                          marginBottom: 12,
                          borderBottom:
                            idx < filteredFaqs.length - 1
                              ? "1px solid #eee"
                              : "none",
                          paddingBottom: 8,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span style={{ fontWeight: 600, fontSize: 16 }}>
                            {faq.keyName}
                          </span>
                          {/* {faq.popular && (
                            <span
                              style={{
                                background: "#f1f2f6",
                                color: "#555",
                                fontSize: 12,
                                borderRadius: 8,
                                padding: "2px 10px",
                                marginLeft: 8,
                              }}
                            >
                              Popular
                            </span>
                          )} */}
                          <div style={{ marginLeft: "auto", color: "#888" }}>
                            <Icon
                              color="black"
                              style={{
                                marginLeft: "5px",
                                color: "black",
                                marginBottom: "-4px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                // setLoading(true);
                                fetch(
                                  `${baseUrl}/faq/get_doc?file_name=${faq?.name}&file_type=${faq?.type}`,
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    // setTimeout(() => {
                                    //   setLoading(false);
                                    // }, 2000);
                                    handleOpenViewDocumentModal(data?.url);
                                  })
                                  .catch((error) => {
                                    console.error("Error:", error);
                                    // setLoading(false);
                                  });
                              }}
                            >
                              launch
                            </Icon>{" "}
                          </div>
                        </div>
                        {/* <div
                          style={{
                            color: "#666",
                            fontSize: 14,
                            margin: "8px 0",
                          }}
                        >
                          {faq.type}
                        </div> */}
                        {/* <button
                          style={{
                            background: "#f1f2f6",
                            color: "#222",
                            border: "none",
                            borderRadius: 8,
                            padding: "4px 14px",
                            fontSize: 13,
                            cursor: "pointer",
                          }}
                        >
                          {faq.tag}
                        </button> */}
                      </div>
                    ))}
                  </div>
                </div>
              </Grid>
            )}
          </Grid>

          <Modal
            open={createDocumentModal}
            onClose={handleCreateCloseDocumentModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={style}>
              <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                  New Supplier Request
                </MDTypography>
                <MDBox>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={handleCreateCloseDocumentModal}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
              </MDBox>
              <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

              <MDBox pt={1} pb={1} px={0}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={formik.handleSubmit}
                >
                  <MDBox mb={2} mt={-2}>
                    <MDInput
                      inputProps={{
                        maxLength: 45,
                      }}
                      label="Supplier Name"
                      type="text"
                      name="vendorName"
                      fullWidth
                      autoComplete="off"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.vendorName}
                      error={
                        formik.touched.vendorName &&
                        formik.errors.vendorName &&
                        true
                      }
                    />
                    {formik.touched.vendorName && formik.errors.vendorName && (
                      <TextError msg={formik.errors.vendorName} />
                    )}
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      label="E-Mail"
                      type="email"
                      name="email"
                      fullWidth
                      autoComplete="off"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      error={
                        formik.touched.email && formik.errors.email && true
                      }
                    />
                    {formik.touched.email && formik.errors.email && (
                      <TextError msg={formik.errors.email} />
                    )}
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      inputProps={{
                        maxLength: 45,
                      }}
                      label="Contact Person"
                      type="text"
                      name="contactPerson"
                      fullWidth
                      autoComplete="off"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson}
                      error={
                        formik.touched.contactPerson &&
                        formik.errors.contactPerson &&
                        true
                      }
                    />
                    {formik.touched.contactPerson &&
                      formik.errors.contactPerson && (
                        <TextError msg={formik.errors.contactPerson} />
                      )}
                  </MDBox>

                  <MDBox>
                    <Collapse in={isErrorCreateUser}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorCreateUser(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsg}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessCreateUser}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessCreateUser(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        New Supplier Request Submitted Successfully
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorForEmail}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorForEmail(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Please check your email domain!
                      </Alert>
                    </Collapse>
                  </MDBox>

                  <MDBox mt={2}>
                    <MDButton
                      // fullWidth
                      style={{ backgroundColor: "red", float: "left" }}
                      color="info"
                      type="submit"
                      disabled={!formik.isValid}
                    >
                      submit
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDCard>
          </Modal>
          <Modal
            open={openViewEventDescModal}
            onClose={handleCloseViewEventDescModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={styleForDesc} style={{ border: "none" }}>
              <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                  Title:- {singleEventDescData?.title}
                </MDTypography>
                <MDBox>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={handleCloseViewEventDescModal}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        padding: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
              </MDBox>

              <hr />
              <MDBox pt={0} pb={0} px={0}>
                <MDBox
                  style={{
                    fontSize: "18px",
                    padding: "10px",
                  }}
                >
                  {singleEventDescData?.description}
                </MDBox>
              </MDBox>
            </MDCard>
          </Modal>
          <Modal
            open={openViewDocumentModal}
            onClose={handleCloseViewDocumentModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={styleForDocument}>
              <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                  View Document
                </MDTypography>
                <MDBox>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={handleCloseViewDocumentModal}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
              </MDBox>

              <hr />

              <MDBox pt={1} pb={3} px={1} height="100%">
                <iframe
                  style={{
                    height: "100%",
                    width: "100%",
                    overflow: "auto",
                  }}
                  src={document}
                ></iframe>
              </MDBox>
            </MDCard>
          </Modal>

          <Modal
            open={openCreateVendorModal}
            onClose={handleCloseCreateVendorModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={styleForSub}>
              <MDTypography>
                Unable to add supplier request: Please subscribe first
              </MDTypography>
              <MDBox mt={2}>
                <MDButton
                  style={{ width: "48%", marginRight: "0.5rem" }}
                  color="info"
                  variant="outlined"
                  onClick={handleCloseCreateVendorModal}
                >
                  Cancel
                </MDButton>
                <MDButton
                  style={{ width: "48%", marginLeft: "0.5rem" }}
                  color="success"
                  onClick={() => navigate("/subscription-plans")}
                >
                  Yes
                </MDButton>
              </MDBox>
            </MDCard>
          </Modal>
        </>
      ) : (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {roleName !== "superadmin" && (
        <div
          style={{
            // bottom: "0",
            // position: "fixed",
            // right: "0",
            marginTop: 10,
          }}
        >
          <Footer />
        </div>
      )}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getNavbarBoxesReducer: state.getNavbarBoxesReducer,
    getVendorStatusCountsReducer: state.getVendorStatusCountsReducer,
    getCircularsForHomeReducer: state.getCircularsForHomeReducer,
    getCalendarsForHomeReducer: state.getCalendarsForHomeReducer,
    getFaqDetailsReducer: state.getFaqDetailsReducer,
    getVendorSubscriptionCountReducer: state.getVendorSubscriptionCountReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getNavbarBoxes: (jwtToken) => dispatch(getNavbarBoxes(jwtToken)),
    getVendorStatusCounts: (jwtToken) =>
      dispatch(getVendorStatusCounts(jwtToken)),
    getCircularsForHome: (jwtToken) => dispatch(getCircularsForHome(jwtToken)),
    getCalendarsForHome: (jwtToken) => dispatch(getCalendarsForHome(jwtToken)),
    getFaqDetails: (jwtToken) => dispatch(getFaqDetails(jwtToken)),

    createVendorRegistrationLink: (payload, jwtToken) =>
      dispatch(createVendorRegistrationLink(payload, jwtToken)),

    getVendorSubscriptionCount: (jwtToken) =>
      dispatch(getVendorSubscriptionCount(jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Home);
